// utils/localstorage.js
export function setWithExpiry(key, value, ttl = 24 * 60 * 60 * 1000) {
  const now = new Date()
  const item = {
    value: value,
    expiry: ttl ? now.getTime() + ttl : null,
  }
  localStorage.setItem(key, JSON.stringify(item))
}

export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  if (item.expiry && now.getTime() > item.expiry) {
    localStorage.removeItem(key)
    return null
  }
  return item.value
}

export function clearSavedStorage(keys) {
  keys.forEach(key => localStorage.removeItem(key))
}
